import { ChangeDetectionStrategy, Component, computed, inject, input } from '@angular/core';
import { AccountKindService } from '@frontendlib/common/services/account-kind.service';
import { SpaceType } from '@sharedlib/common/types/SpaceType';
import { SpaceContextStore } from '@modules/common/services/SpaceContextStore';
import { type TaskWaiting } from './row-status';
@Component({
  selector: 'app-task-waiting-mark',
  changeDetection: ChangeDetectionStrategy.OnPush,
  template: `@if (waiting(); as mark) {
    <p class="px-2 text-xs">Waiting · {{ mark.reason }}</p>
  }`,
})
export class TaskWaitingMarkComponent {
  public readonly task = input.required<{ accountId?: string; waiting?: TaskWaiting | null }>();
  private readonly context = inject(SpaceContextStore);
  private readonly accountKind = inject(AccountKindService);
  protected readonly waiting = computed(() => {
    const task = this.task();
    return task.waiting &&
      this.accountKind.isTeam() &&
      this.context.type() === SpaceType.SHARED_SPACE &&
      task.accountId === this.context.contextId()
      ? task.waiting
      : null;
  });
}
